import { render, staticRenderFns } from "./Opcionais.vue?vue&type=template&id=7d144250&"
import script from "./Opcionais.vue?vue&type=script&lang=js&"
export * from "./Opcionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports